export default class AddFlaggedIssueViewModel {
    public templateId: number = 0;
    public sectionId: number = 0;
    public questionId: number = 0;
    public completeId: number = 0;
    public notes: string = '';
    public callRefId: string = '';

    constructor(templateId?: number, completeId?: number, callRefId?: string) {
        if (templateId)
            this.templateId = templateId;

        if (completeId)
            this.completeId = completeId;

        if (callRefId)
            this.callRefId = callRefId;
    }
}